export enum NotificationType {
  MARKETING = 'MARKETING',
  INFORMATIONAL = 'INFORMATIONAL',
  SYSTEM_ALERT = 'SYSTEM_ALERT',
  NEW_ASSESSMENT = 'NEW_ASSESSMENT',
  COMPLETED_ASSESSMENT = 'COMPLETED_ASSESSMENT',
  COMPLETED_SCAN = 'COMPLETED_SCAN',
}

export class Notification {
  public id?: number;
  public isRead?: boolean;
  public type?: NotificationType;
  public userId?: number;
  public referenceIds?: number[];
  public subject?: string;
  public message?: string;
  public createdAt?: Date;

  constructor(obj: Notification = {} as Notification) {
    this.id = obj.id;
    this.isRead = obj.isRead;
    this.type = obj.type;
    this.userId = obj.userId;
    this.referenceIds = obj.referenceIds;
    this.subject = obj.subject;
    this.message = obj.message;
    this.createdAt = obj.createdAt;
  }
}